import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Statistic,
  Progress,
  Table,
  Tag,
  Space,
  Button,
  Typography,
  Spin,
  message,
  Avatar,
  List,
  Tooltip,
  Badge,
  Timeline,
  Divider,
  Alert,
  Select,
  DatePicker,
} from "antd";
import {
  UserOutlined,
  ShoppingCartOutlined,
  DollarCircleOutlined,
  RiseOutlined,
  DownloadOutlined,
  EyeOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  TeamOutlined,
  ShopOutlined,
  BarChartOutlined,
  LineChartOutlined,
  PieChartOutlined,
  CalendarOutlined,
  BellOutlined,
  SettingOutlined,
  ReloadOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  FireOutlined,
  StarOutlined,
  TrophyOutlined,
  RocketOutlined,
  ThunderboltOutlined,
  HeartOutlined,
  CrownOutlined,
  GiftOutlined,
  SafetyOutlined,
  BankOutlined,
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  InfoCircleOutlined,
  WarningOutlined,
  ExclamationCircleOutlined,
  GlobalOutlined,
  MobileOutlined,
  CloudOutlined,
  SecurityScanOutlined,
  MonitorOutlined,
  DatabaseOutlined,
  ApiOutlined,
  BugOutlined,
  ToolOutlined,
  HomeOutlined,
  FolderOutlined,
  FileOutlined,
  PictureOutlined,
  VideoCameraOutlined,
  SoundOutlined,
  ProfileOutlined,
  ContactsOutlined,
  ScheduleOutlined,
  ProjectOutlined,
  FundOutlined,
  StockOutlined,
  TruckOutlined,
  InboxOutlined,
  TagOutlined,
  FilterOutlined,
  SearchOutlined,
  SortAscendingOutlined,
  ExpandOutlined,
  CompressOutlined,
  SyncOutlined,
  PrinterOutlined,
  ShareAltOutlined,
  ExportOutlined,
  ImportOutlined,
  UploadOutlined,
  CopyOutlined,
  ScissorOutlined,
  HighlightOutlined,
  FontSizeOutlined,
  BoldOutlined,
  ItalicOutlined,
  UnderlineOutlined,
  AlignLeftOutlined,
  AlignCenterOutlined,
  AlignRightOutlined,
  OrderedListOutlined,
  UnorderedListOutlined,
  TableOutlined,
  PlusOutlined,
  MinusOutlined,
  EditOutlined,
  DeleteOutlined,
  SaveOutlined,
  UndoOutlined,
  RedoOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
  FullscreenOutlined,
  PauseOutlined,
  PlayCircleOutlined,
  StepForwardOutlined,
  StepBackwardOutlined,
  FastForwardOutlined,
  FastBackwardOutlined,
  VerticalAlignTopOutlined,
  VerticalAlignBottomOutlined,
  MenuOutlined,
  AppstoreOutlined,
  UnlockOutlined,
  LockOutlined,
  KeyOutlined,
  WifiOutlined,
  UsbOutlined,
  PoweroffOutlined,
  LoginOutlined,
  LogoutOutlined,
  SwapOutlined,
  RollbackOutlined,
  EnterOutlined,
  RetweetOutlined,
  ForwardOutlined,
  BackwardOutlined,
  CaretRightOutlined,
  CaretLeftOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  QuestionOutlined,
  QuestionCircleOutlined,
  DashboardOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const { Title, Text, Paragraph } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

const AdminDashBoard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState({
    users: { total: 0, active: 0, pending: 0, inactive: 0 },
    orders: { total: 0, pending: 0, completed: 0, cancelled: 0, amount: 0 },
    products: { total: 0, downloaded: 0, popular: [] },
    activities: { total: 0, recent: [] },
    notifications: [],
    performance: { uptime: 99.9, response: 120, errors: 2 },
    highIntentLeads: 0,
  });
  const [timeRange, setTimeRange] = useState("today");
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    fetchDashboardData();
  }, [timeRange]);

  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      let leadsCount = 0;
      try {
        const keys = ["token", "accessToken", "AuthToken", "jwtToken"];
        let token = null;
        for (const k of keys) {
          const v = localStorage.getItem(k);
          if (v) {
            token = v.replace(/^"|"$/g, "");
            break;
          }
        }
        if (!token) {
          try {
            const user = JSON.parse(localStorage.getItem("user") || "{}");
            token = user?.token || user?.accessToken || null;
          } catch {}
        }

        if (token && global.config?.APIURL?.BaseURL) {
          const res = await axios.get(
            `${global.config.APIURL.BaseURL}api/HighIntentLeads/GetHighIntentLeads`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          leadsCount = Array.isArray(res.data) ? res.data.length : 0;
        }
      } catch (err) {
        console.error("Error fetching leads:", err);
      }

      // Simulate API calls - replace with actual API endpoints
      const mockData = {
        users: {
          total: 1248,
          active: 892,
          pending: 156,
          inactive: 200,
          growth: 12.5,
        },
        orders: {
          total: 3456,
          pending: 234,
          completed: 2890,
          cancelled: 332,
          amount: 2456789,
          growth: 18.3,
        },
        products: {
          total: 5678,
          downloaded: 45632,
          popular: [
            { name: "Premium Tiles", downloads: 1234, icon: "🏠" },
            { name: "Luxury Marble", downloads: 987, icon: "✨" },
            { name: "Modern Design", downloads: 756, icon: "🎨" },
          ],
        },
        activities: {
          total: 12456,
          recent: [
            {
              action: "New User Registration",
              user: "John Doe",
              time: "2 min ago",
            },
            { action: "Order Placed", user: "Jane Smith", time: "5 min ago" },
            {
              action: "Product Downloaded",
              user: "Mike Johnson",
              time: "8 min ago",
            },
          ],
        },
        notifications: [
          {
            type: "info",
            message: "System maintenance scheduled for tonight",
            time: "1 hour ago",
          },
          {
            type: "warning",
            message: "Storage usage at 85%",
            time: "2 hours ago",
          },
          {
            type: "success",
            message: "Backup completed successfully",
            time: "3 hours ago",
          },
        ],
        performance: {
          uptime: 99.9,
          response: 120,
          errors: 2,
          cpu: 45,
          memory: 68,
          disk: 72,
        },
      };

      setTimeout(() => {
        setDashboardData({ ...mockData, highIntentLeads: leadsCount });
        setLoading(false);
      }, 1000);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      message.error("Failed to load dashboard data");
      setLoading(false);
    }
  };

  const handleRefresh = async () => {
    setRefreshing(true);
    await fetchDashboardData();
    setRefreshing(false);
    message.success("Dashboard refreshed successfully");
  };

  const getGrowthIcon = (growth) => {
    return growth > 0 ? (
      <ArrowUpOutlined style={{ color: "#52c41a" }} />
    ) : (
      <ArrowDownOutlined style={{ color: "#ff4d4f" }} />
    );
  };

  const getGrowthColor = (growth) => {
    return growth > 0 ? "#52c41a" : "#ff4d4f";
  };

  const quickActionsData = [
    {
      title: "Dashboard",
      icon: <DashboardOutlined />,
      action: () => navigate("/AdminDashBoard"),
      color: "#1890ff",
    },
    {
      title: "Manage Product",
      icon: <ShopOutlined />,
      action: () => navigate("/AdminCategory"),
      color: "#52c41a",
    },
    {
      title: "New Arrival",
      icon: <StarOutlined />,
      action: () => navigate("/ManageNewArrival"),
      color: "#722ed1",
    },
    {
      title: "Product Tags",
      icon: <TagOutlined />,
      action: () => navigate("/ManageProductTags"),
      color: "#fa8c16",
    },
    {
      title: "LastChance Deals",
      icon: <FireOutlined />,
      action: () => navigate("/ManageLastChanceDeals"),
      color: "#ff4d4f",
    },
    {
      title: "Trending Items",
      icon: <RiseOutlined />,
      action: () => navigate("/ManageTrendingItems"),
      color: "#13c2c2",
    },
    {
      title: "User List",
      icon: <UserOutlined />,
      action: () => navigate("/UserList"),
      color: "#eb2f96",
    },
    {
      title: "Activity Summary",
      icon: <BarChartOutlined />,
      action: () => navigate("/UserActivitySummary"),
      color: "#f5222d",
    },
    {
      title: "Insta Post Schedule",
      icon: <ScheduleOutlined />,
      action: () => navigate("/InstaPostSchedule"),
      color: "#a0d911",
    },
  ];

  const recentOrdersColumns = [
    {
      title: "Order ID",
      dataIndex: "orderId",
      key: "orderId",
      render: (id) => <Text strong>#{id}</Text>,
    },
    {
      title: "Customer",
      dataIndex: "customer",
      key: "customer",
      render: (customer) => (
        <Space>
          <Avatar size="small" icon={<UserOutlined />} />
          <Text>{customer}</Text>
        </Space>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => <Text strong>₹{amount.toLocaleString("en-IN")}</Text>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag
          color={
            status === "completed"
              ? "green"
              : status === "pending"
              ? "orange"
              : "red"
          }
        >
          {status.toUpperCase()}
        </Tag>
      ),
    },
  ];

  const recentOrdersData = [
    { orderId: 1234, customer: "John Doe", amount: 15000, status: "completed" },
    { orderId: 1235, customer: "Jane Smith", amount: 25000, status: "pending" },
    {
      orderId: 1236,
      customer: "Mike Johnson",
      amount: 18000,
      status: "completed",
    },
  ];

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        <Spin size="large" />
        <div style={{ marginTop: "16px" }}>
          <Text>Loading dashboard...</Text>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "24px",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      {/* Header */}
      <div style={{ marginBottom: "24px" }}>
        <Row justify="space-between" align="middle">
          <Col>
            <Title level={2} style={{ margin: 0, color: "#1890ff" }}>
              <DashboardOutlined style={{ marginRight: "8px" }} />
              Admin Dashboard
            </Title>
            <Text type="secondary">
              Welcome back! Here's what's happening today.
            </Text>
          </Col>
          <Col>
            <Space>
              <Select
                value={timeRange}
                onChange={setTimeRange}
                style={{ width: 120 }}
                size="small"
              >
                <Option value="today">Today</Option>
                <Option value="week">This Week</Option>
                <Option value="month">This Month</Option>
                <Option value="year">This Year</Option>
              </Select>
              <Button
                icon={<ReloadOutlined />}
                onClick={handleRefresh}
                loading={refreshing}
                type="primary"
                size="small"
              >
                Refresh
              </Button>
            </Space>
          </Col>
        </Row>
      </div>

      {/* Key Metrics */}
      <Row gutter={[16, 16]} style={{ marginBottom: "24px" }}>
        <Col xs={24} sm={12} md={6}>
          <Card
            hoverable
            onClick={() => navigate("/LeadsToApprove")}
            style={{ cursor: "pointer", height: "100%" }}
          >
            <Statistic
              title="High Intent Leads"
              value={dashboardData.highIntentLeads}
              prefix={<FireOutlined style={{ color: "#ff4d4f" }} />}
              valueStyle={{ color: "#ff4d4f" }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="Total Orders"
              value={dashboardData.orders.total}
              prefix={<ShoppingCartOutlined style={{ color: "#52c41a" }} />}
              suffix={
                <span
                  style={{
                    fontSize: "12px",
                    color: getGrowthColor(dashboardData.orders.growth),
                  }}
                >
                  {getGrowthIcon(dashboardData.orders.growth)}{" "}
                  {dashboardData.orders.growth}%
                </span>
              }
              valueStyle={{ color: "#52c41a" }}
            />
            <Progress
              percent={Math.round(
                (dashboardData.orders.completed / dashboardData.orders.total) *
                  100
              )}
              size="small"
              strokeColor="#52c41a"
              style={{ marginTop: "8px" }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="Total Revenue"
              value={dashboardData.orders.amount}
              prefix={<DollarCircleOutlined style={{ color: "#fa8c16" }} />}
              formatter={(value) => `₹${value.toLocaleString("en-IN")}`}
              valueStyle={{ color: "#fa8c16" }}
            />
            <Text type="secondary" style={{ fontSize: "12px" }}>
              <RiseOutlined style={{ color: "#52c41a", marginRight: "4px" }} />
              +15.3% from last month
            </Text>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="Downloads"
              value={dashboardData.products.downloaded}
              prefix={<DownloadOutlined style={{ color: "#722ed1" }} />}
              valueStyle={{ color: "#722ed1" }}
            />
            <Text type="secondary" style={{ fontSize: "12px" }}>
              <FireOutlined style={{ color: "#ff4d4f", marginRight: "4px" }} />
              Hot trending!
            </Text>
          </Card>
        </Col>
      </Row>

      {/* Quick Actions */}
      <Card
        title={
          <>
            <RocketOutlined /> Quick Actions
          </>
        }
        style={{ marginBottom: "24px" }}
      >
        <Row gutter={[16, 16]}>
          {quickActionsData.map((item, index) => (
            <Col xs={24} sm={12} md={6} lg={4} xl={3} key={index}>
              <Card
                hoverable
                size="small"
                style={{
                  textAlign: "center",
                  borderColor: item.color,
                  transition: "all 0.3s",
                }}
                onClick={item.action}
              >
                <div
                  style={{
                    color: item.color,
                    fontSize: "24px",
                    marginBottom: "8px",
                  }}
                >
                  {item.icon}
                </div>
                <Text strong style={{ fontSize: "12px" }}>
                  {item.title}
                </Text>
              </Card>
            </Col>
          ))}
        </Row>
      </Card>

      {/* Main Content */}
      <Row gutter={[16, 16]}>
        {/* Users Overview */}
        <Col xs={24} lg={8}>
          <Card
            title={
              <>
                <TeamOutlined /> Users Overview
              </>
            }
            extra={
              <Button type="link" onClick={() => navigate("/users")}>
                View All
              </Button>
            }
          >
            <Row gutter={16}>
              <Col span={12}>
                <Statistic
                  title="Active Users"
                  value={dashboardData.users.active}
                  prefix={<CheckCircleOutlined style={{ color: "#52c41a" }} />}
                  valueStyle={{ color: "#52c41a", fontSize: "18px" }}
                />
              </Col>
              <Col span={12}>
                <Statistic
                  title="Pending"
                  value={dashboardData.users.pending}
                  prefix={<ClockCircleOutlined style={{ color: "#faad14" }} />}
                  valueStyle={{ color: "#faad14", fontSize: "18px" }}
                />
              </Col>
            </Row>
            <Divider />
            <div style={{ textAlign: "center" }}>
              <Progress
                type="circle"
                percent={Math.round(
                  (dashboardData.users.active / dashboardData.users.total) * 100
                )}
                size={80}
                strokeColor="#52c41a"
              />
              <div style={{ marginTop: "8px" }}>
                <Text type="secondary">Active Rate</Text>
              </div>
            </div>
          </Card>
        </Col>

        {/* Orders Overview */}
        <Col xs={24} lg={8}>
          <Card
            title={
              <>
                <ShoppingCartOutlined /> Orders Overview
              </>
            }
            extra={
              <Button type="link" onClick={() => navigate("/orders")}>
                View All
              </Button>
            }
          >
            <Space direction="vertical" style={{ width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Text>Completed</Text>
                <Text strong style={{ color: "#52c41a" }}>
                  {dashboardData.orders.completed}
                </Text>
              </div>
              <Progress
                percent={Math.round(
                  (dashboardData.orders.completed /
                    dashboardData.orders.total) *
                    100
                )}
                strokeColor="#52c41a"
                size="small"
              />

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Text>Pending</Text>
                <Text strong style={{ color: "#faad14" }}>
                  {dashboardData.orders.pending}
                </Text>
              </div>
              <Progress
                percent={Math.round(
                  (dashboardData.orders.pending / dashboardData.orders.total) *
                    100
                )}
                strokeColor="#faad14"
                size="small"
              />

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Text>Cancelled</Text>
                <Text strong style={{ color: "#ff4d4f" }}>
                  {dashboardData.orders.cancelled}
                </Text>
              </div>
              <Progress
                percent={Math.round(
                  (dashboardData.orders.cancelled /
                    dashboardData.orders.total) *
                    100
                )}
                strokeColor="#ff4d4f"
                size="small"
              />
            </Space>
          </Card>
        </Col>

        {/* System Performance */}
        <Col xs={24} lg={8}>
          <Card
            title={
              <>
                <MonitorOutlined /> System Performance
              </>
            }
          >
            <Space direction="vertical" style={{ width: "100%" }}>
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "4px",
                  }}
                >
                  <Text>Uptime</Text>
                  <Text strong style={{ color: "#52c41a" }}>
                    {dashboardData.performance.uptime}%
                  </Text>
                </div>
                <Progress
                  percent={dashboardData.performance.uptime}
                  strokeColor="#52c41a"
                  size="small"
                />
              </div>

              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "4px",
                  }}
                >
                  <Text>CPU Usage</Text>
                  <Text strong style={{ color: "#1890ff" }}>
                    {dashboardData.performance.cpu}%
                  </Text>
                </div>
                <Progress
                  percent={dashboardData.performance.cpu}
                  strokeColor="#1890ff"
                  size="small"
                />
              </div>

              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "4px",
                  }}
                >
                  <Text>Memory</Text>
                  <Text strong style={{ color: "#722ed1" }}>
                    {dashboardData.performance.memory}%
                  </Text>
                </div>
                <Progress
                  percent={dashboardData.performance.memory}
                  strokeColor="#722ed1"
                  size="small"
                />
              </div>

              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "4px",
                  }}
                >
                  <Text>Disk Space</Text>
                  <Text strong style={{ color: "#fa8c16" }}>
                    {dashboardData.performance.disk}%
                  </Text>
                </div>
                <Progress
                  percent={dashboardData.performance.disk}
                  strokeColor="#fa8c16"
                  size="small"
                />
              </div>
            </Space>
          </Card>
        </Col>
      </Row>

      {/* Bottom Section */}
      <Row gutter={[16, 16]} style={{ marginTop: "24px" }}>
        {/* Recent Orders */}
        <Col xs={24} lg={12}>
          <Card
            title={
              <>
                <ShoppingCartOutlined /> Recent Orders
              </>
            }
            extra={
              <Button type="link" onClick={() => navigate("/orders")}>
                View All
              </Button>
            }
          >
            <Table
              columns={recentOrdersColumns}
              dataSource={recentOrdersData}
              pagination={false}
              size="small"
              rowKey="orderId"
            />
          </Card>
        </Col>

        {/* Recent Activities */}
        <Col xs={24} lg={12}>
          <Card
            title={
              <>
                <BellOutlined /> Recent Activities
              </>
            }
            extra={
              <Button type="link" onClick={() => navigate("/activities")}>
                View All
              </Button>
            }
          >
            <Timeline size="small">
              {dashboardData.activities.recent.map((activity, index) => (
                <Timeline.Item
                  key={index}
                  dot={<Avatar size="small" icon={<UserOutlined />} />}
                >
                  <div>
                    <Text strong>{activity.action}</Text>
                    <br />
                    <Text type="secondary">
                      {activity.user} • {activity.time}
                    </Text>
                  </div>
                </Timeline.Item>
              ))}
            </Timeline>
          </Card>
        </Col>
      </Row>

      {/* Popular Products */}
      <Card
        title={
          <>
            <StarOutlined /> Popular Products
          </>
        }
        style={{ marginTop: "24px" }}
        extra={
          <Button type="link" onClick={() => navigate("/products")}>
            View All
          </Button>
        }
      >
        <Row gutter={[16, 16]}>
          {dashboardData.products.popular.map((product, index) => (
            <Col xs={24} sm={8} key={index}>
              <Card size="small" hoverable>
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: "24px", marginBottom: "8px" }}>
                    {product.icon}
                  </div>
                  <Text strong>{product.name}</Text>
                  <br />
                  <Text type="secondary">
                    <DownloadOutlined style={{ marginRight: "4px" }} />
                    {product.downloads} downloads
                  </Text>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Card>

      {/* Notifications */}
      <Card
        title={
          <>
            <BellOutlined /> System Notifications
          </>
        }
        style={{ marginTop: "24px" }}
      >
        <List
          dataSource={dashboardData.notifications}
          renderItem={(item, index) => (
            <List.Item key={index}>
              <List.Item.Meta
                avatar={
                  <Avatar
                    style={{
                      backgroundColor:
                        item.type === "info"
                          ? "#1890ff"
                          : item.type === "warning"
                          ? "#faad14"
                          : item.type === "success"
                          ? "#52c41a"
                          : "#ff4d4f",
                    }}
                    icon={
                      item.type === "info" ? (
                        <InfoCircleOutlined />
                      ) : item.type === "warning" ? (
                        <WarningOutlined />
                      ) : item.type === "success" ? (
                        <CheckCircleOutlined />
                      ) : (
                        <ExclamationCircleOutlined />
                      )
                    }
                  />
                }
                title={item.message}
                description={item.time}
              />
            </List.Item>
          )}
        />
      </Card>
    </div>
  );
};

export default AdminDashBoard;
